app.service("NavigationManager", ['$rootScope', '$state', '$stateParams', 'SiteHelper', 'ModelConstructor', function ($rootScope, $state, $stateParams, SiteHelper, ModelConstructor) {

    const navigationManager = this;

    const siteHelper = SiteHelper;

    let browseActive = false;

    this.NavigationModel = function () {
        this.state_ids = {};
        this.state_values = {};
        this.state_models = {};
        this.state_choices = {};
        this.state_list = [];

        this.choice_count = 0;

        this.route_options = {};
        this.href = "";
    }

    this.model = new this.NavigationModel();
    const routeNavigationModel = this.model;


    let navigationInitialized = false;
    const onInitializedListeners = [];

    function testPrint(value) {
        if (navigationInitialized) {
            return
        }
        console.log(value)
    }

    function collectActiveState() {

        const wasActive = browseActive;

        browseActive = $state.$current && $state.$current.data ? !!$state.$current.data.is_browse : null;

        if (!browseActive && !wasActive) {
            handleInitialized();
            return;
        }

        const routePath = collectNavigationRoutePath();

        navigationManager.populateNavigationModel(routeNavigationModel, routePath);

        if (!browseActive) {
            broadcastStateChange();
            handleInitialized();
            return;
        }

        testPrint("routeNavigationModel")
        testPrint(routeNavigationModel)

        broadcastStateChange();
        handleInitialized();

    }

    function collectNavigationRoutePath() {
        let nextIndex = 0;
        const routePath = [];
        while (true) {
            if (!$stateParams.hasOwnProperty("value_" + nextIndex)) {
                break;
            }
            routePath.push(siteHelper.slugToID($stateParams["value_" + nextIndex]));
            nextIndex++;
        }
        return routePath;
    }

    this.createNavigationModel = function (routePath, routeIDs, selectDefaults, toModelID) {
        const navigationModel = new navigationManager.NavigationModel();
        navigationManager.populateNavigationModel(navigationModel, routePath, routeIDs, selectDefaults, toModelID);
        return navigationModel;
    }

    this.populateNavigationModel = function (navigationModel, routePath, routeIDs, selectDefaults, toModelID) {
        resetNavigationModel(navigationModel);
        if (navigationModel !== routeNavigationModel && !routeIDs) {
            mergeWithNavigation(navigationModel, routePath);
        }
        determineNavigationState(navigationModel, routePath, routeIDs, selectDefaults, toModelID);
        const lastModel = navigationModel.state_list.length ? navigationModel.state_list[navigationModel.state_list.length - 1].model : null;
        navigationModel.route_options = lastModel ? lastModel.route_options : null;
        navigationModel.href = lastModel ? lastModel.href : null;
    }


    function resetNavigationModel(navigationModel) {

        siteHelper.resetObject(navigationModel.state_ids);
        siteHelper.resetObject(navigationModel.state_values);
        siteHelper.resetObject(navigationModel.state_models);
        siteHelper.resetObject(navigationModel.state_choices);

        navigationModel.state_list.length = 0;

        navigationModel.choice_count = 0;
    }

    function mergeWithNavigation(navigationModel, routePath) {
        for (let i = 0; i < routePath.length; i++) {
            let choiceID = routePath[i];
            const navigationState = routeNavigationModel.state_list[i];
            if (!navigationState || (navigationState.choice_id !== choiceID && navigationState.public_id !== choiceID)) {
                break;
            }
            choiceID = navigationState.choice_id;
            const modelID = navigationState.model_id;
            const model = navigationState.model;
            const choice = navigationState.choice;
            const navigationPointer = navigationState.navigation_pointer;
            navigationModel.state_list.push({
                model_id: modelID,
                choice_id: choiceID,
                model: model,
                choice: choice,
                navigation_pointer: navigationPointer,
                public_id: navigationState.public_id,
                state_ids: siteHelper.simpleCloneObject(navigationState.state_ids),
                state_values: siteHelper.simpleCloneObject(navigationState.state_values)
            });
            siteHelper.simpleCloneObject(navigationState.state_ids, navigationModel.state_ids)
            siteHelper.simpleCloneObject(navigationState.state_values, navigationModel.state_values)
            navigationModel.state_models[modelID] = model;

            if (choice) {
                navigationModel.state_choices[modelID] = choice;
            }
        }
    }

    function determineNavigationState(navigationModel, routePath, routeIDs, selectDefaults, toModelID) {

        if (!routePath && !routeIDs) {
            return;
        }
        let nextModelID = null;

        const publicIdList = [];
        if (navigationModel.state_list.length) {
            let lastChoice = null;
            for (let i = 0; i < navigationModel.state_list.length; i++) {
                const state = navigationModel.state_list[i];
                const choice = state.choice;
                if (!choice) {
                    break;
                }
                lastChoice = choice;
                publicIdList.push(state.public_id);
            }

            if (lastChoice) {
                nextModelID = lastChoice.next_model_id ? lastChoice.next_model_id : null;
            }

        } else {
            nextModelID = "browse";
        }

        const useRouteIDs = !!routeIDs;

        let arrayIndex = navigationModel.state_list.length - 1;
        let indexStateIDs = {};
        let indexStateValues = {};
        let endReached = false;
        while (nextModelID && !endReached) {
            const model = nextModelID && $rootScope.factory[nextModelID] ? $rootScope.factory[nextModelID].getModel(navigationModel.state_ids) : null;
            if (!model || !model.is_route_model || navigationModel.state_models[model.id] || !model.navigation_pointer) {
                break;
            }
            const modelID = model.id;
            applyRouteToModel(model, publicIdList);

            if (modelID === toModelID) {
                endReached = true;
            }

            const navigationPointer = model.navigation_pointer;
            nextModelID = null;
            let choiceID = null;
            let isHiddenModel = false;
            if (model.choice_order.length === 0 && !model.stop_if_choice_route_empty) {
                nextModelID = model.next_model_id;
                if (nextModelID) {
                    continue;
                }
            }
            if (navigationModel.state_ids[navigationPointer]) {
                choiceID = navigationModel.state_ids[navigationPointer];
                isHiddenModel = true;
            } else if (model.choice_order.length === 1 && !model.allow_single_choice_route) {
                choiceID = model.choice_order[0];
                isHiddenModel = true;
            } else {
                arrayIndex++;
                if (useRouteIDs) {
                    choiceID = routeIDs[navigationPointer];
                } else {
                    choiceID = routePath[arrayIndex];
                }
                if (!choiceID && selectDefaults) {
                    if (model.default_choice_id) {
                        choiceID = model.default_choice_id;
                    }
                }
            }

            choiceID = choiceID && model.public_choice_ids[choiceID] ? model.public_choice_ids[choiceID] : choiceID;

            let choice = choiceID ? model.choices[choiceID] : null;
            choice = choice ? choice : null;

            choiceID = choice ? choice.id : null;
            const publicID = choiceID && choice.public_id ? choice.public_id : choiceID;

            navigationModel.state_models[modelID] = model;

            if (choice) {
                navigationModel.state_choices[modelID] = choice;

                indexStateIDs[navigationPointer] = choiceID;
                if (choice.state_ids) {
                    for (let key in choice.state_ids) {
                        const stateID = choice.state_ids[key];
                        if (stateID && !navigationModel.state_ids[key] && !indexStateIDs[key]) {
                            indexStateIDs[key] = stateID;
                        }
                    }
                }
                siteHelper.simpleCloneObject(indexStateIDs, navigationModel.state_ids)
                if (choice.state_values) {
                    for (let key in choice.state_values) {
                        const stateValue = choice.state_values[key];
                        if (!navigationModel.hasOwnProperty(key) && !indexStateValues.hasOwnProperty(key)) {
                            indexStateValues[key] = stateValue;
                        }
                    }
                }
                siteHelper.simpleCloneObject(indexStateValues, navigationModel.state_values)

                nextModelID = choice.next_model_id;

            }

            if (!isHiddenModel) {
                navigationModel.state_list.push({
                    model_id: modelID,
                    choice_id: choiceID,
                    model: model,
                    choice: choice,
                    navigation_pointer: navigationPointer,
                    public_id: publicID,
                    state_ids: indexStateIDs,
                    state_values: indexStateValues
                });

                publicIdList.push(publicID);

                indexStateIDs = {};
                indexStateValues = {};
            } else {

                if (navigationModel.state_list.length) {
                    siteHelper.simpleCloneObject(indexStateIDs, navigationModel.state_list[navigationModel.state_list.length - 1].state_ids);
                    indexStateIDs = {};
                    siteHelper.simpleCloneObject(indexStateValues, navigationModel.state_list[navigationModel.state_list.length - 1].state_values);
                    indexStateValues = {};
                }
            }
        }

        let choiceCount = 0;
        for (let i = navigationModel.state_list.length - 1; i >= 0; i--) {
            const choice = navigationModel.state_list[i].choice;
            if (choice) {
                choiceCount = i + 1;
                break;
            }
        }

        navigationModel.choice_count = choiceCount;
    }

    function applyRouteToModel(model, publicIdList) {

        if (model.route_options) {
            return
        }
        for (let choiceID in model.choices) {
            const choice = model.choices[choiceID];
            const publicID = choice.public_id ? choice.public_id : choiceID;
            publicIdList.push(publicID);
            choice.route_options = constructRouteOptions(publicIdList);
            choice.href = choice.route_options ? $state.href(choice.route_options.route, choice.route_options.options) : null;
            choice.navigation_pointer = model.navigation_pointer;
            publicIdList.pop();
        }
        model.route_options = constructRouteOptions(publicIdList);
        model.href = model.route_options ? $state.href(model.route_options.route, model.route_options.options) : null;
    }

    function constructRouteOptions(publicIdList) {

        let route = "myba.browse";
        const options = {};

        for (let i = 0; i < publicIdList.length; i++) {
            const publicID = publicIdList[i];
            if (!publicID) {
                break;
            }

            options["value_" + i] = siteHelper.idToSlug(publicID);
            route += ".value-" + i;
        }

        return {
            route: route,
            options: options
        }
    }

    this.forkNavigationPath = function (modelID, addRoutePath) {

        const forkedPath = [];

        for (let i = 0; i < routeNavigationModel.state_list.length; i++) {
            const stateModel = routeNavigationModel.state_list[i].model;
            if (modelID === stateModel.id) {
                for (let j = 0; j < addRoutePath.length; j++) {
                    forkedPath.push(addRoutePath[j]);
                }
                break;
            }
            const choice = routeNavigationModel.state_list[i].choice;
            if (!choice) {
                break;
            }
            forkedPath.push(choice.id);
        }
        return forkedPath;
    }

    this.requireChildState = function (modelID) {
        const stateList = routeNavigationModel.state_list;
        const lastPathModelID = stateList.length > 0 ? stateList[stateList.length - 1].model_id : null;
        if (lastPathModelID === modelID) {
            const model = routeNavigationModel.state_models[modelID];
            if (model) {
                let defaultChoice = model.default_choice_id ? model.choices[model.default_choice_id] : null;
                if (!defaultChoice) {
                    const choiceList = model.choiceList();
                    defaultChoice = choiceList.length > 0 ? choiceList[0] : null;
                }
                if (defaultChoice) {
                    const routePath = navigationManager.forkNavigationPath(defaultChoice.model_id, [defaultChoice.id]);
                    const routeOptions = navigationManager.createNavigationModel(routePath).route_options;
                    if (routeOptions) {
                        $state.go(routeOptions.route, routeOptions.options, {location: 'replace'})
                    }
                }
            }
        }
    }

    function getModelIndex(forModelID) {
        for (let i = 0; i < routeNavigationModel.state_list.length; i++) {
            const indexState = routeNavigationModel.state_list[i];
            if (indexState.model_id === forModelID) {
                return i;
            }
        }
        return -1;
    }

    this.getStateIDs = function (forIndex, forModelID) {
        if (forModelID) {
            forIndex = getModelIndex(forModelID);
        }
        const stateIDs = {};
        if (forIndex < 0) {
            return stateIDs;
        }
        for (let i = 0; i < routeNavigationModel.state_list.length; i++) {
            const indexState = routeNavigationModel.state_list[i];
            if (i === forIndex) {
                return stateIDs;
            }
            for (let key in indexState.state_ids) {
                stateIDs[key] = indexState.state_ids[key];
            }
        }
        return stateIDs;
    }

    this.getStateValues = function (forIndex, forModelID) {
        if (forModelID) {
            forIndex = getModelIndex(forModelID);
        }
        const stateValues = {};
        if (forIndex < 0) {
            return stateValues;
        }
        for (let i = 0; i < routeNavigationModel.state_list.length; i++) {
            const indexState = routeNavigationModel.state_list[i];
            if (i === forIndex) {
                return stateValues;
            }
            for (let key in indexState.state_values) {
                stateValues[key] = indexState.state_values[key];
            }
        }
        return stateValues;
    }

    function broadcastStateChange() {
        $rootScope.$broadcast("browse_navigation_state_change");
    }

    function handleInitialized() {
        if (navigationInitialized) {
            return
        }
        navigationInitialized = true;
        for (let i = 0; i < onInitializedListeners.length; i++) {
            onInitializedListeners[i]();
        }
        onInitializedListeners.length = 0;
    }

    this.requireInitialized = function (callback) {
        if (navigationInitialized) {
            callback();
            return;
        }
        onInitializedListeners.push(callback);
    }

    this.initNavigation = function () {

        $rootScope.service.cache_local_server.requireInitialized(function () {

            collectActiveState();

            $rootScope.$on('$stateChangeSuccess', function ($event, next, current) {
                collectActiveState();
            });
        });
    }


}])